import apiClient from '../api/apiClient'
import { CreateAreaForm, UpdateAreaForm, AreaApiResponse, SingleAreaApiResponse } from '../../types'

export const areaService = {
  // Get all areas
  getAllAreas: async (page?: number, limit?: number, activeOnly = false): Promise<AreaApiResponse> => {
    const params: any = {}
    if (page !== undefined) params.page = page + 1 // API uses 1-based indexing
    if (limit !== undefined) params.limit = limit
    if (activeOnly) params.active_only = true
    const response = await apiClient.get('/admin/areas/get-all', { params })
    return response.data
  },

  // Get single area
  getArea: async (id: string): Promise<SingleAreaApiResponse> => {
    const response = await apiClient.get(`/admin/areas/${id}`)
    return response.data
  },

  // Create a new area
  createArea: async (data: CreateAreaForm): Promise<SingleAreaApiResponse> => {
    const response = await apiClient.post('/admin/areas/create', data)
    return response.data
  },

  // Update an area
  updateArea: async (id: string, data: UpdateAreaForm): Promise<SingleAreaApiResponse> => {
    const response = await apiClient.put(`/admin/areas/${id}`, data)
    return response.data
  },

  // Disable an area through the existing DELETE endpoint
  deleteArea: async (id: string): Promise<{ success: boolean; message?: string }> => {
    const response = await apiClient.delete(`/admin/areas/${id}`)
    return response.data
  },
}
